import { j as e } from "../../../../jsx-runtime.BREq8dyb.js";
import { DataSourceType as a, DataTargetType as t } from "@decentriq/graphql/dist/enums";
import { listSubheaderClasses as q, RadioGroup as L, List as d, ListItem as l, ListItemDecorator as p, Tooltip as f, Box as g, Radio as m, ListSubheader as v } from "@mui/joy";
import { memo as R } from "react";
import { S as I, a as w, L as b, l as O, d as _ } from "../../../../index.BRz-o-Vs.js";
import x, { DqDatasetSyncIconSize as S } from "../DqDatasetSyncIcon/DqDatasetSyncIcon.js";
const P = {
  "--List-gap": "0.5rem",
  "--List-padding": "0",
  "--ListDivider-gap": "1rem",
  "--ListItem-paddingX": "0.75rem",
  "--ListItem-paddingY": "0.75rem",
  "--ListItem-radius": "var(--joy-radius-sm)",
  "--ListItemDecorator-size": "32px",
  [`& .${q.root}`]: {
    minBlockSize: "auto",
    padding: 0
  }
}, y = {
  root: {
    sx: {
      flexDirection: "row-reverse",
      flexGrow: 1
    }
  }
}, z = [b.Table, b.Unstructured], B = [a.Local, a.S3, a.Azure, a.GoogleCloudStorage, a.Databricks, a.Permutive, a.Salesforce, a.Snowflake], C = [t.S3, t.Azure, t.GoogleCloudStorage, t.Adform, t.GoogleAdManager, t.GoogleAds, t.GoogleDv_360, t.Meta, t.MicrosoftDsp, t.Permutive, t.Snapchat, t.Splicky, t.Sportradar, t.Tiktok, t.TradeDesk], E = "To activate this feature, please reach out to your customer success manager or send an email to support@decentriq.com.", X = R(({
  syncDirection: G,
  value: k = [null, null],
  onChange: u,
  getFilteredItems: j,
  getDisabledItems: D
}) => {
  const [A, M] = k, h = M || A;
  switch (G) {
    case I.IMPORT: {
      const o = B, n = j?.(o) || o, c = D?.(o) || [], r = n.filter((s) => s !== a.Local), i = n.some((s) => s === a.Local);
      return /* @__PURE__ */ e.jsx(L, { onChange: (s) => {
        z.includes(s.target.value) ? u?.([a.Local, s.target.value]) : u?.([s.target.value, null]);
      }, value: h, children: /* @__PURE__ */ e.jsxs(d, { sx: P, children: [
        i && /* @__PURE__ */ e.jsxs(l, { nested: !0, children: [
          /* @__PURE__ */ e.jsx(v, { children: "From your computer" }),
          /* @__PURE__ */ e.jsx(d, { children: z.map((s) => /* @__PURE__ */ e.jsxs(l, { variant: "outlined", children: [
            /* @__PURE__ */ e.jsx(p, { children: /* @__PURE__ */ e.jsx(
              x,
              {
                size: S.sm,
                syncType: s
              }
            ) }),
            /* @__PURE__ */ e.jsx(m, { disabled: c.includes(a.Local), label: O[s], overlay: !0, slotProps: y, value: s })
          ] }, s)) })
        ] }),
        /* @__PURE__ */ e.jsxs(l, { nested: !0, children: [
          /* @__PURE__ */ e.jsx(v, { children: "From external source" }),
          /* @__PURE__ */ e.jsx(d, { children: r.map((s) => {
            const T = c.includes(s);
            return /* @__PURE__ */ e.jsxs(l, { variant: "outlined", children: [
              /* @__PURE__ */ e.jsx(p, { children: /* @__PURE__ */ e.jsx(x, { size: S.sm, syncType: s }) }),
              /* @__PURE__ */ e.jsx(f, { component: g, title: T && E, children: /* @__PURE__ */ e.jsx(m, { disabled: T, label: _[s], overlay: !0, slotProps: y, value: s }) })
            ] }, s);
          }) })
        ] })
      ] }) });
    }
    case I.EXPORT: {
      const o = C, n = j?.(o) || o, c = D?.(o) || [];
      return /* @__PURE__ */ e.jsx(L, { onChange: (r) => u?.([r.target.value, null]), value: h, children: /* @__PURE__ */ e.jsx(d, { sx: P, children: n.map((r) => {
        const i = c.includes(r);
        return /* @__PURE__ */ e.jsxs(l, { variant: "outlined", children: [
          /* @__PURE__ */ e.jsx(p, { children: /* @__PURE__ */ e.jsx(
            x,
            {
              size: S.sm,
              syncType: r
            }
          ) }),
          /* @__PURE__ */ e.jsx(f, { component: g, title: i && E, children: /* @__PURE__ */ e.jsx(m, { disabled: i, label: w[r], overlay: !0, slotProps: y, value: r }) })
        ] }, r);
      }) }) });
    }
    default:
      return null;
  }
});
X.displayName = "DqDatasetSyncsList";
export {
  X as default
};
//# sourceMappingURL=DqDatasetSyncsList.js.map
